import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { useMemo } from "react";
import {PythonTaskData} from "../../../serviceapi/jobRunnerApi";
import Utils from "util/Utils";

interface TestDataDialogProps {
  isVisible: boolean;
  setIsVisible: (isVisible: boolean) => void;
  testData: PythonTaskData;
}

const TestDataDialog = ({
  isVisible,
  setIsVisible,
  testData,
}: TestDataDialogProps) => {
  const jsonString = useMemo(
    () => JSON.stringify(testData, null, 2),
    [testData]
  );

  const headerTemplate = () => {
    return (
      <div className="flex justify-content-start align-items-center gap-3">
        <div>Test Data</div>
        <Button
          icon="pi pi-clone"
          className="p-button-text ml-2 custom-button"
          onClick={() => Utils.copyToClipboard(jsonString)}
          tooltip="Copy test data"
          tooltipOptions={{ position: "bottom" }}
        />
        <Button
          icon="pi pi-download"
          className="p-button-text custom-button"
          onClick={() => Utils.downloadStringToTxt(jsonString, "test-data.json")}
          tooltip="Download test data"
          tooltipOptions={{ position: "bottom" }}
        />
      </div>
    );
  };

  return (
    <Dialog
      header={headerTemplate}
      style={{
        width: "50%",
        height: "100%",
        position: "absolute",
        bottom: 0,
        right: 0,
      }}
      visible={isVisible}
      onHide={() => setIsVisible(false)}
      modal={false}
    >
      <pre>{jsonString}</pre>
    </Dialog>
  );
};

export default TestDataDialog;
